import { defineMessages, useIntl } from "react-intl";
import store from "../redux/initializeRedux";
import { STATUSES } from "./workOrderStatus";
import Cookies from "universal-cookie";

const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

const messages = defineMessages({
    statusComplete: {
        id: "globals-langHelpers.status-Complete",
        defaultMessage: "Complete",
        description: "status of task being complete",
    },
});

export const useLocalizedName = () => {
    const intl = useIntl();
    return { getLocalizedName: (args) => getLocalizedNameWithIntl(intl, args) };
};

// pull in obj and return correct string based on state's lang
export const getLocalizedNameWithIntl = (intl, { object, value, defaultString }) => {
    value = value || "name";
    defaultString = defaultString || "";
    if (!object) {
        return defaultString;
    }
    return object[getLangDbKey(intl, value)] || object[value + capitalizeFirstLetter(intl.locale)] || defaultString;
};

export const getLangDbKey = (intl, value) => {
    return value + "_" + intl.locale;
};

export const getlabourerTaskStatus = (intl, status = {}) => {
    if (status.id && [STATUSES.PENDING_REVIEW].includes(status.id)) {
        return intl.formatMessage(messages.statusComplete);
    }
    return getLocalizedNameWithIntl(intl, { object: status });
};

export const getLangFromCookies = () => {
    const cookies = new Cookies();
    const cookiesLocale = cookies.get("locale");

    return cookiesLocale;
};
